<template>
    <div class="relative min-h-screen antialiased bg-white sans-serif">
        <div class="flex justify-between">
            <div class="absolute top-5 right-5 md:right-20 transform -translate-center">
                <AppLogo />
            </div>
            <div class="absolute top-20 right-5 md:right-20">
                <div class="flex gap-4">
                    <div class="flex items-center gap-4">
                        <t-button @click="printStatement" variant="success" class="flex flex-row gap-2"> Print
                            <PrintIcon class="w-5" />
                        </t-button>
                        <t-button @click="exportToPDF()" variant="outline" class="px-4 py-2">Download PDF</t-button>
                    </div>
                    <button title="Reload" class="p-1 rounded-full cursor-pointer hover:bg-gray-200" @click="reload">
                        <ReplaceIcon />
                    </button>
                </div>
            </div>
        </div>

        <div id="printContent" ref="pdfContent">
            <StatementTemplate :data="user" :loggeduser="loggedUser" />
        </div>
    </div>
</template>

<script>
import print from 'vue-print-nb';
import html2pdf from 'html2pdf.js';
import AppLogo from '@/Components/AppLogo.vue';
import common from '../common';
import ReplaceIcon from '@/Components/Icons/ReplaceIcon.vue';
import PrintIcon from '@/Components/Icons/PrintIcon.vue';
import StatementTemplate from '@/Components/Templates/StatementTemplate.vue';

export default {
    name: 'RetailerStatement',

    directives: {
        print,
    },

    components: {
        AppLogo,
        ReplaceIcon,
        PrintIcon,
        StatementTemplate,
    },

    props: {
        user: {
            type: Object,
            default: null,
        },
        loggedUser: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            common,
        };
    },

    methods: {
        reload() {
            window.location.reload();
        },

        async printStatement() {
            await this.$htmlToPaper('printContent');
        },

        exportToPDF() {
            const element = this.$refs.pdfContent;

            const opt = {
                margin: [0.1, 0.1],
                filename: `Customer_Statement_${this.user.name}.pdf`,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2 },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
            };

            html2pdf().from(element).set(opt).save();
        },
    },
};
</script>
